export default [
  {
    label: "Ein-/Zweifamilienhaus",
    value: "8",
  },
  {
    label: "Mehrfamilienhaus",
    value: "3",
  },
];
